const isEmpty = (obj: any) => {
  return Object.keys(obj).length === 0
}

const formatPrice = (price: number = 1, min = 0, max = 8) => {
  if (!price) return '';
  return price.toLocaleString('en-US', {
    minimumFractionDigits: min,
    maximumFractionDigits: max,
  }).toString();
};

const omit = (keys, obj) => {
  if (!keys.length) return obj
  const { [keys.pop()]: omitted, ...rest } = obj;
  return omit(keys, rest);
}

const extractor = (object: any ,params: readonly string[]) => {
  const data = {};

  params.map(e => {
    if (object) {
      data[e] = object[e]
    }
  });

  return data;
};

const selectFormatter = (array: any[], value: string, label: string, firstOption: string = '') => {
  const newArray = [];

  if (firstOption){
    newArray.push({
      value: '',
      label: firstOption
    })
  }

  array?.length && Array.isArray(array) && array?.map(e => newArray.push({
    value: e[value],
    label: e[label]
  }))

  return newArray
};

const extractChildren = (node: any, array: any[], index: number = 0, depth = 0) => {
  ++depth;

  let newTitle = ''
  for (let i = 1; i < depth; i++) {
    newTitle += '-'
  }

  const j = { ...node, title: node.title + newTitle }

  array.push(j)

  if (j.children) {
    j.children.map(e => {
      return extractChildren(e, array, ++index, depth)
    })
  }
  return array;
}

const hasAccess = (userAccesses, accesses, roleId) => {
  if (roleId == 2){
    return true;
  }
  const arr = Array.isArray(accesses) ? accesses : [accesses]
  for (let i = 0; i < userAccesses.length; i++) {
    for (let j = 0; j < arr.length ; j++) {
      if(userAccesses[i].slug == arr[j]){
        return true
      }
    }
  }
  return false
};
const orderStatusIs = (status, statuses) => {
  return statuses.filter(e => {
    return status == e;
  }).length > 0;
}

const sortByMatching = () => {

};
export default {
  orderStatusIs,
  hasAccess,
  isEmpty,
  omit,
  formatPrice,
  extractor,
  selectFormatter,
  extractChildren
};